import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Shadow extends React.Component {
  static propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    component: 'div',
    size: 'xs',
    className: undefined,
    children: null,
  };

  render() {
    const { component: Component, size, className, children, ...props } = this.props;

    const shadowClasses = clx(
      {
        [`size-${size}`]: size,
      },
      className
    );

    return (
      <Component className={shadowClasses} {...props}>
        {children}
      </Component>
    );
  }
}
